'use client';

import { UploadArea, UploadButton } from '@pixum/imagegrid';
import {
  getAcceptedFileFormats,
  getAcceptedFileFormatsAsMimeType
} from '@pixum/image-upload-service/lib/get-accepted-file-formats';
import { getMaxFileSizeInMb } from '@pixum/image-upload-service/lib/file-size';
import { GlobalDialog } from '@pixum/dialog-service/lib/components';
import styles from './ImageUploader.module.css';
import { useExpressDesignerService } from '../../hooks/useExpressDesignerService';
import { useUploadProgress } from '../../hooks/useUploadProgress';
import { FILE_UPLOAD_CTA_INPUT_ID } from '../../constants';

interface ImageUploaderProps {
  constants: Record<string, string>;
  userId: string;
}

export function ImageUploader({ constants, userId }: ImageUploaderProps) {
  const { serviceRef, dialogService } = useExpressDesignerService({ userId, constants });
  const { hasUploads, totalProgress } = useUploadProgress();

  const handleFileChange = (files: File[]) => {
    serviceRef.current?.imageService.upload.uploadImages(files);
  };

  const fileInputProps = {
    accept: getAcceptedFileFormatsAsMimeType().join(', '),
    multiple: true,
    id: FILE_UPLOAD_CTA_INPUT_ID
  };

  return (
    <>
      <div className={styles.imageUploaderDesktop}>
        <UploadArea
          constants={{
            dragElementHere: constants['i18n_drag_photos_here_or'],
            fileEnding: constants['i18n_file_ending_jpeg_jpg_heic_heif'],
            fileSize: constants['i18n_file_size_50'],
            uploadPhotos: constants['i18n_upload_photos']
          }}
          availableFileTypes={getAcceptedFileFormats()}
          maxFileSizeInMb={getMaxFileSizeInMb()}
          hasUploads={hasUploads}
          totalProgress={totalProgress}
          onFileChange={handleFileChange}
          fileInputProps={fileInputProps}
        />
      </div>
      <div className={styles.imageUploaderMobile}>
        <UploadButton
          constants={{ uploadPhotos: constants['i18n_upload_photos'] }}
          fileInputProps={fileInputProps}
          hasUploads={hasUploads}
          totalProgress={totalProgress}
          onFileChange={handleFileChange}
        />
      </div>
      {dialogService && <GlobalDialog dialogService={dialogService} />}
    </>
  );
}
